export const filterOutVoidItems = (items = []) => {
  return items.filter(item => !item.isVoidItem);
};